'use client';

import { Checkbox } from '@ps/ui/atoms/checkbox';

interface Props {
  value: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
}

/**
 * Broadcast-channel toggle for Create / Edit Channel modals. Mirrors
 * PopshopRN's `BroadcastField`: single checkbox + help text below.
 *
 * A broadcast channel restricts message-sending to the creator; fans
 * can only react with emojis. The toggle flips
 * `CommunityChannel.isBroadcastChannel` on the server.
 */
export function ChannelBroadcastField({ value, onChange, disabled }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-content-1 flex items-center gap-2 text-sm font-medium">
        <Checkbox
          checked={value}
          onCheckedChange={next => onChange(next === true)}
          disabled={disabled}
          className="data-[state=checked]:border-brand data-[state=checked]:bg-brand data-[state=checked]:text-content-on-brand border-line-strong"
        />
        This is a Broadcast Channel
      </label>
      <p className="text-content-3 text-xs leading-snug">
        Broadcast channel allows you to post messages to your fans, but fans
        cannot post messages in return. They can only react with emojis.
      </p>
    </div>
  );
}
